import EmployeeOnboardingMaterials from "../../../../src/pages/use-cases/page-content/content-publishing/employee-onboarding-materials.md";
import * as React from 'react';
export default {
  EmployeeOnboardingMaterials,
  React
};